<template>
  <div class="stepModal position-relative">
    <div class="modal fade"  id="subsite-modal" tabindex="-1" role="dialog" aria-labelledby="ipModal">
      <div class="modal-dialog modal-lg" role="document" style="width: 1190px; max-width:1190px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> Subsites </h5>
          </div>
          <div class="modal-body">
            <section v-if="loading">
              <div class="loader"></div>
            </section>
            <section v-if="!loading && subsites.length > 0">
              <table class="table table-hover">
                <thead>
                <th>URL</th>
                <th>Action</th>
                </thead>
                <tbody>
                <tr v-for="(row, index) of subsites" :key="index">
                  <td>
                    <span> {{ row.url }}</span>
                  </td>
                  <td>
                    <div v-if="deleting === row.blog_id" class="loader" style="width:20px; height: 20px; margin: 0"></div>
                    <button v-else class="btn btn-sm btn-danger my-1" @click="deleteSubsite(row)" ><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "subsiteModal",
  props: {
    docID: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      account: {},
      loading: false,
      deleting: null,
      subsites: []
    }
  },
  methods: {
    async deleteSubsite (row) {
      const result = await swal({
        title: "Remove Subsite!",
        text: `Are you sure you want to delete this subsite?`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      if (!result.value) {
        return
      }
      this.deleting = row.blog_id
      try {
        const res = await this.$http.post('/subsites/delete', {
          domain: this.account.domain,
          ip: this.account.serverIP,
          subsiteid: row.blog_id,
          grant_type: 'token',
        })
        if (res.data.success) {
          this.getSubsites();
          swal({
            title: "Success",
            html:  `Successfully deleted subsite: ${row.url}.`,
            type: "success"
          })
        } else {
          swal({
            title: "Error",
            html: `${res.data.error}`,
            type: "error"
          })
        }
      } catch (e) {
        swal({
          title: "Error",
          html: `Error in deleting subsite ${row.url}. Please contact support!`,
          type: "error"
        })
        console.log('Error in deleting subsite', e.toString())
      }
      this.deleting = null
    },
    async getSubsites() {
      this.subsites = []
      try {
        const res = await this.$http.post('/subsites/list', {
          domain: this.account.domain,
          ip: this.account.serverIP,
          grant_type: 'token',
        })
        if (res.data.success) {
          this.subsites = res.data.subsites
        }
      } catch (e) {
        console.log(e.toString())
      }
    },
    async load(account) {
      this.loading = true
      this.subsites = []
      $('#subsite-modal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
      this.account = account;
      console.log('calling', account)
      await this.getSubsites();
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>